import $axios from './index'

export function getBIOne(data) {
    const url = '/api/bi/sale_count/get_company_device_sort'
    return $axios.get(url, data)
}

// 景区列表
export function getStoreList(data) {
    const url = '/api/bi/basic/get_company_list'
    return $axios.get(url, data)
}
// 总览数据
export function getScreeningList(data) {
    const url = '/api/bi/sale_count/get_sale_by_company_device_sku'
    return $axios.get(url, data)
}


